<div class="no-connection">
    <div class="icon"></div>
    <h1>You're Offline</h1>
    <p>It seems like you’ve lost your internet connection. Please check your network settings to get back online.</p>
</div>
